import { get, post, put, remove } from "./APICaller";

export const login = (params) => {
  return post(`${process.env.REACT_APP_API_URL}/api/auth/local`, params);
};

export const register = (params) => {
  return post(
    `${process.env.REACT_APP_API_URL}/api/auth/local/register`,
    params
  );
};

export const getProfile = () => {
  return get(`${process.env.REACT_APP_API_URL}/api/users/me?populate=*`);
};

export const getNominees = ({ page = 1 }) => {
  return get(
    `${process.env.REACT_APP_API_URL}/api/nominatees?populate=*&pagination[page]=${page}`
  );
};

export const getNominee = (api_path) => {
  return get(`${process.env.REACT_APP_API_URL}${api_path}?populate=deep`);
};

export const createNominee = (params) => {
  return post(`${process.env.REACT_APP_API_URL}/api/nominatees`, params);
};

export const updateNominee = (api_path, params) => {
  return put(`${process.env.REACT_APP_API_URL}${api_path}`, params);
};

export const getNominators = () => {
  return get(`${process.env.REACT_APP_API_URL}/api/nominators?populate=deep`);
};

export const updateNominator = (api_path, params) => {
  return put(`${process.env.REACT_APP_API_URL}${api_path}`, params);
};

export const uploadFile = (file) => {
  let params = new FormData();
  params.append("files", file);
  return post(`${process.env.REACT_APP_API_URL}/api/upload`, params, {
    "Content-Type": "multipart/form-data",
  });
};

export const emailConfirmation = (params) => {
  return get(
    `${process.env.REACT_APP_API_URL}/api/auth/email-confirmation`,
    params
  );
};

export const requestForgotPassword = (params) => {
  return post(
    `${process.env.REACT_APP_API_URL}/api/auth/forgot-password`,
    params
  );
};

export const actAsUser = (params) => {
  return post(
    `${process.env.REACT_APP_API_URL}/api/nomination/act-as-user`,
    params
  );
};

export const destroyActAsUser = () => {
  return remove(`${process.env.REACT_APP_API_URL}/api/nomination/act-as-user`);
};

export const resetPassword = (params) => {
  return post(
    `${process.env.REACT_APP_API_URL}/api/auth/reset-password`,
    params
  );
};

export const getSetting = () => {
  return get(`${process.env.REACT_APP_API_URL}/api/settings`);
};

export const updateSetting = (id, params) => {
  return put(`${process.env.REACT_APP_API_URL}/api/settings/${id}`, params);
};

export const getNomineesDeep = () => {
  return get(
    `${process.env.REACT_APP_API_URL}/api/nominatees?populate=deep&pagination[pageSize]=100&filters[users_permissions_user][self_registration][$eq]=true`
  );
};

export const exportData = () => {
  return post(`${process.env.REACT_APP_API_URL}/api/reports`);
};

export const downloadAttachment = () => {
  return post(`${process.env.REACT_APP_API_URL}/api/reports/attachments/download`);
};

export const deleteCommercializationMission = (id) => {
  return remove(
    `${process.env.REACT_APP_API_URL}/api/commercialization-missions/${id}`
  );
};

export const deleteNominator = (id) => {
  return remove(
    `${process.env.REACT_APP_API_URL}/api/nominators/${id}`
  );
};

export const deleteNominatee = (id) => {
  return remove(
    `${process.env.REACT_APP_API_URL}/api/nominatees/${id}`
  );
};

export const getEmailLogs = (page, pageSize, searchText = "") => {
  let url = `${process.env.REACT_APP_API_URL}/api/messages?populate=deep&pagination[page]=${page}&pagination[pageSize]=${pageSize}&sort[id]=desc`;

  if (searchText) {
    url += `&filters[to][$containsi]=${encodeURIComponent(searchText)}`;
  }

  return get(url);
};


export const getEmailDetail = (id) => {
  return get(`${process.env.REACT_APP_API_URL}/api/messages/${id}`);
};

export const deleteScienceMission = (id) => {
  return remove(`${process.env.REACT_APP_API_URL}/api/science-missions/${id}`);
};

export const deleteDiploma = (id) => {
  return remove(`${process.env.REACT_APP_API_URL}/api/diplomas/${id}`);
};

export const deleteMonograph = (id) => {
  return remove(`${process.env.REACT_APP_API_URL}/api/monographs/${id}`);
};

export const deleteScienceArticle = (id) => {
  return remove(
    `${process.env.REACT_APP_API_URL}/api/scientific-articles/${id}`
  );
};

export const deleteInventionAward = (id) => {
  return remove(`${process.env.REACT_APP_API_URL}/api/invention-awards/${id}`);
};

export const getNominatorsByType = (is_org, page, total) => {
  return get(
    `${process.env.REACT_APP_API_URL}/api/nominators?populate=deep&filters[is_org][$eqi]=${is_org}&pagination[page]=${page}&pagination[pageSize]=${total}`
  );
};

export const resendEmail = async ( params) => {
  return post(`${process.env.REACT_APP_API_URL}/api/reports/send-email/create-job`, params);
};